import * as React from 'react';
import MuiButton from '@material-ui/core/IconButton';
import { Color } from './types';

type Props = {
  disabled: boolean;
  color: Color;
  onClick: () => void;
  children: any;
}

function IconButton(props: Props) {
  function onClick(e) {
    e.preventDefault();
    e.stopPropagation();

    props.onClick();
  }

  return (
    <MuiButton
      disabled={props.disabled}
      color={props.color}
      onClick={onClick}
    >
      {props.children}
    </MuiButton>
  );
}

IconButton.defaultProps = {
  disabled: false,
  color: 'primary',
};

export default IconButton;



// WEBPACK FOOTER //
// ./src/common/components/ui/IconButton.js